import Avatar from "@/components/Avatar";
// import CoverImage from "@/components/cover-image";
import PostTitle from "@/components/PostTitle";
import Link from "next/link";

const PostHeader = ({
  title,
  categories,
  coverImage,
  date,
  author,
  prefix = "/news",
}) => {
  return (
    <div className="mx-auto max-w-2xl">
      {categories.edges.length > 0 ? (
        categories.edges.map((category, index) => (
          <Link
            key={index}
            href={`${prefix}/categories/${category.node.slug}`}
            className="body-section-header sm:text-center lg:text-left"
          >
            {category.node.name}
            {index < categories.edges.length - 1 && <>,&nbsp;</>}
          </Link>
        ))
      ) : (
        <Link
          key={index}
          href={`${prefix}/categories/${category.node.slug}`}
          className="body-section-header sm:text-center lg:text-left"
        >
          {categories.edges.node.name}
        </Link>
      )}
      <PostTitle title={title} />
      <div className="hidden md:block">
        <Avatar author={author} date={date} />
      </div>
      {/* <div className="mb-8 sm:mx-0 md:mb-16">
          <CoverImage title={title} src={coverImage} />
        </div> */}
      <div>
        <div className="block md:hidden">
          <Avatar author={author} date={date} />
        </div>
      </div>
    </div>
  );
};

export default PostHeader;
